import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default class Modal {
	constructor() {
		this.galleryCards = document.querySelectorAll('[data-gallery-card]');
		this.modalGalleryCards = document.querySelectorAll('[data-modal-card]');

		this.modal = document.querySelector('[data-modal]');
		this.modalPrevious = document.querySelector('[data-modal-prev]');
		this.modalNext = document.querySelector('[data-modal-next]');
		this.modalClose = document.querySelector('[data-modal-close]');

		this.currentIndex = 0;
		this.galleryAmount = this.galleryCards.length;

		this.init();
	}

	init() {
		if (!this.galleryAmount) {
			return;
		}

		this.attachEventListeners();

		this.modalGalleryCards.forEach((card) => {
			card.style.display = 'none';
		});
	}

	attachEventListeners() {
		this.galleryCards.forEach((card, index) => {
			card.addEventListener('click', () => this.openModal(index));
		});

		this.modalPrevious?.addEventListener('click', () => this.showPreviousImage());
		this.modalNext?.addEventListener('click', () => this.showNextImage());
		this.modalClose?.addEventListener('click', () => this.closeModal());
		this.modal?.addEventListener('click', (event) => {
			if (event.target === this.modal) {
				this.closeModal();
			}
		});

		// Add event listener to copy link
		this.modalGalleryCards.forEach((card) => {
			const link = card.querySelector('[data-modal-copy]');
			link.addEventListener('click', (event) => this.copyLinkToClipboard(event));
		});
	}

	openModal(index) {
		this.modal.style.display = 'block';
		this.currentIndex = index;
		this.showImage();
		this.updateModalNavigation();

		disableBodyScroll(this.modal);
	}

	closeModal() {
		this.modal.style.display = 'none';

		clearAllBodyScrollLocks();
	}

	showImage() {
		this.modalGalleryCards.forEach((card) => {
			card.style.display = 'none';
			if (card.dataset.id == this.currentIndex) {
				card.style.display = 'block';
			}
		});
	}

	updateModalNavigation() {
		const isFirstImage = this.currentIndex === 0;
		const isLastImage = this.currentIndex === this.galleryCards.length - 1;
		this.modalPrevious.disabled = isFirstImage;
		this.modalNext.disabled = isLastImage;
	}

	showPreviousImage() {
		if (this.currentIndex > 0) {
			this.currentIndex--;
			this.showImage();
			this.updateModalNavigation();
		}
	}

	showNextImage() {
		if (this.currentIndex < this.galleryCards.length - 1) {
			this.currentIndex++;
			this.showImage();
			this.updateModalNavigation();
		}
	}

	copyLinkToClipboard(event) {
		event.preventDefault();
		const link = event.target;
		const data = link.dataset.link;
		console.log(link);

		// Create a temporary input element
		const input = document.createElement('input');
		input.style.opacity = '0';
		input.value = data;
		document.body.appendChild(input);

		// Select the input's value and copy it to the clipboard
		input.select();
		input.setSelectionRange(0, input.value.length);
		document.execCommand('copy');

		// Remove the temporary input element
		document.body.removeChild(input);
	}
}
